import { pilot } from '~/services/serviceInstances';

import {
  AlertListItem,
  GetAlertsParams,
  PaginatedResponse,
} from './alert.types';

export type GetAlertsRequest = {
  page?: number;
  filters?: GetAlertsParams;
};

export type GetAlertsResponse = PaginatedResponse<AlertListItem>;

export const getAlerts = ({ page = 1, filters = {} }: GetAlertsRequest) =>
  pilot.get<GetAlertsResponse>('/alert/', { params: { page, ...filters } });
